import React from 'react';
import './EmpowerSection.css';


const About2 = () => {
  return (
    <section className="about2-section">
      <div className="about2-container">
        <div className="about2-grid">
          {/* Left Column */}
          <div className="about2-text">
            <h1 className="about2-title">
              Supporting the Next Generation of Quantum Innovators.
            </h1>
            <p className="about2-description">
            Quantumke is the leading quantum tech community in Kenya, uniting over 500 members—including researchers, industry experts, academics, and enthusiasts—who are passionate about shaping the future of quantum technologies. Since 2021, we've championed research, education, and outreach in quantum technologies. 
            </p>
          </div>
          
          {/* Right Column - Video */}
          <div className="about2-video-container">
            <iframe 
              className="about2-video"
              src="https://www.youtube.com/embed/nS2x3XnG4Ww?si=KWWrZztrNaA4sDtf"
              title="Promotional Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About2;
